import { writable, get } from 'svelte/store';
import { encode, decode } from './utilities.js';
import { toastMessage } from './store.js';

export const socket = writable(false);
socket.connect = function (uuid, board) {
  return false;
}
socket.disconnect = function () {
  return false;
}
socket.sendBoard = function () {
  return false;
}
